export function QPicRef() {
  this.fWSMgr = null;
  this.fPictureMgr = null;
  this.fCurOrg = null;
  this.fDirectory = null;
  this.fFileName = null;
  //	this.fURL = null;
  this.fCallBack = null;
  this.fDestPanel = null;
  this.fCmdSource = null;
}
